export default __webpack_public_path__ + "static/media/moratorium-icons.d3973cd4.svg";